/**
 * feeDefinitionsApi — cliente del CRUD de fee_definitions expuesto por payment.
 *
 * payment es dueño de la tabla (misma base que lee resolve_fees para la
 * liquidación). Este cliente llama a `GET/POST /api/fee-definitions` con el JWT
 * de sesión de Clerk del staff (payment valida email @yooldigital.com vía
 * @clerk/backend). tadmin no toca la tabla directo para escribir (RLS solo deja
 * escribir a service_role).
 *
 * La URL de yoolpay se deriva del hostname en runtime (ver baseUrl.js).
 */

import { yoolpayBaseUrl } from './baseUrl.js';

const YOOLPAY_BASE_URL = yoolpayBaseUrl();

async function request(path, token, options = {}) {
  const res = await fetch(`${YOOLPAY_BASE_URL}${path}`, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...(options.headers || {}),
    },
  });
  const body = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(body?.error || `payment respondió ${res.status}`);
  }
  return body;
}

/** Lista las definiciones de fee activas. `token` = Clerk session JWT del staff. */
export async function listFeeDefinitions(token) {
  const body = await request('/api/fee-definitions', token);
  return body.fees ?? [];
}

/** Crea una definición de fee (payment hace el supersede + is_active=true). */
export async function createFeeDefinition(token, feeDefinition) {
  return request('/api/fee-definitions', token, {
    method: 'POST',
    body: JSON.stringify(feeDefinition),
  });
}
